import { Box, Flex, Button, Text } from '@cad-arc';
import { LoadingIndicator } from '../loading-indicator';
import { ExportProps } from './export';

export function ExportCard({
    body,
    currentExports,
    onClearAll,
    onDownloadAll,
    isLoading,
}: ExportProps) {
    const disableButton = isLoading || !currentExports.length;

    return (
        <Flex direction="column">
            {currentExports.length > 0 && (
                <Box px={4} py={4}
                    borderBottom="sm"
                    borderColor="border.default">
                    <Text variant="headingMd">Exports ({currentExports.length})</Text>
                </Box>
            )}

            <Box maxH="250px" h={isLoading ? '88px' : undefined} overflowY="auto" px={4} py={4}>
                {isLoading ? <LoadingIndicator /> : body}
            </Box>

            {currentExports.length > 1 && (
                <Flex
                    justifyContent="flex-end"
                    gap={2}
                    p={4}
                    borderTop="sm"
                    borderColor="border.default"
                >
                    <Button variant="ghost" onClick={onClearAll} disabled={disableButton}>
                        Clear All
                    </Button>
                    <Button variant="outline" onClick={onDownloadAll} disabled={disableButton}>
                        Download All
                    </Button>
                </Flex>
            )}
        </Flex>
    );
}
